import $ from 'jquery';
import '../vendors/slick';

if( $( "html" ).attr("dir") == "rtl" ) {
	var rtl = true;
} else {
	var rtl = false;
}

$( '.c-video-carousel' ).slick( {
	rtl: rtl,
	slidesToShow: 3,
	slidesToScroll: 1,
	arrows: true,
	dots: true,
	rows: 0,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 760,
			settings: {
				slidesToShow: 1,
				arrows: false
			}
		},
	]
} );
